module.exports = __webpack_public_path__ + "public/img/vertical_logo_dark.2775847b.svg";